import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@cargomatic/ui';
export function TableSelectionAlert({ selectedCount, totalCount, children, onClearSelection, }) {
    if (selectedCount === 0)
        return null;
    return (React.createElement("div", { role: "status", className: "flex items-center justify-between rounded-md border bg-muted/50 px-4 py-2 mb-4" },
        React.createElement("span", { className: "text-sm text-muted-foreground" },
            selectedCount,
            " of ",
            totalCount,
            " row(s) selected"),
        React.createElement("div", { className: "flex items-center gap-2" },
            children,
            onClearSelection && (React.createElement(Button, { variant: "ghost", size: "sm", onClick: onClearSelection, "aria-label": "Clear selection" },
                React.createElement(X, { className: "h-4 w-4" }))))));
}
